<template>
<div class="info-page">
  <div class="logo-con">
    <img class="logo" :src="checkQiNiuUrl('ant-wx/202311081420/logo-ygsq.jpg?imageView2/2/w/280/format/png')" alt="">
  </div>
  <div class="title-con">
    <div class="title">云柑支付推广达人报名表</div>
    <div class="title-sub">（省市区县服务商限时赠送）</div>
  </div>
  <div class="form-con">
    <van-form ref="form">
      <van-field
          v-model="form.name"
          :rules="formRules.name"
          name="name"
          label="姓名"
          placeholder="姓名"
      />
      <van-field
          :rules="formRules.gender"
          name="gender"
          label="性别"
      >
        <template #input>
          <van-radio-group v-model="form.gender" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
          v-model="form.age"
          :rules="formRules.age"
          name="age"
          label="年龄"
          placeholder="年龄"
      />
      <van-field
          v-model="form.phone"
          :rules="formRules.phone"
          name="phone"
          label="手机号"
          placeholder="手机号(云柑社区注册账号)"
      />

      <van-field
          v-model="form.nativePlace"
          :rules="formRules.nativePlace"
          name="nativePlace"
          is-link
          readonly
          label="籍贯"
          placeholder="请选择籍贯"
          @click="showNativePlace = true"
      />
      <van-popup v-model="showNativePlace" round position="bottom">
        <van-cascader
            v-model="cascaderNativePlace"
            title="请选择籍贯"
            :options="nativePlaceOptions"
            :field-names="fieldNames"
            @close="showNativePlace = false"
            @change="onNativePlaceChange"
            @finish="onNativePlaceFinish"
        />
      </van-popup>

      <van-field
          v-model="form.permanent"
          :rules="formRules.permanent"
          name="permanent"
          is-link
          readonly
          label="常住地区"
          placeholder="请选择常住地区"
          @click="showPermanent = true"
      />
      <van-popup v-model="showPermanent" round position="bottom">
        <van-cascader
            v-model="cascaderPermanent"
            title="请选择常住地区"
            :options="permanentOptions"
            :field-names="fieldNames"
            @close="showPermanent = false"
            @change="onPermanentChange"
            @finish="onPermanentFinish"
        />
      </van-popup>

      <van-field
          v-model="form.inviterName"
          :rules="formRules.inviterName"
          name="inviterName"
          label="邀请人姓名"
          placeholder="邀请人姓名"
      />
      <van-field
          v-model="form.inviterPhone"
          :rules="formRules.inviterPhone"
          name="inviterPhone"
          label="邀请人手机号"
          placeholder="邀请人手机号"
      />

      <van-field
          v-model="form.industryName"
          :rules="formRules.industryName"
          name="industryName"
          label="行业"
          placeholder="所属行业"
      />
<!--      <van-field
          is-link
          readonly
          clickable
          v-model="form.industryName"
          :rules="formRules.industryName"
          label="industryName"
          placeholder="选择行业"
          @click="showIndustryNamePicker = true"
      />
      <van-popup v-model="showIndustryNamePicker" round position="bottom">
        <van-picker
            show-toolbar
            :columns="industries"
            value-key="industryName"
            @cancel="showIndustryNamePicker = false"
            @confirm="onIndustriesConfirm"
        />
      </van-popup>-->

      <van-field
          :rules="formRules.jobWay"
          name="jobWay"
          label="兼职/全职"
      >
        <template #input>
          <van-radio-group v-model="form.jobWay" direction="horizontal">
            <van-radio name="0">兼职</van-radio>
            <van-radio name="1">全职</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
          class="jobIntention"
          :rules="formRules.jobIntention"
          name="jobIntention"
          label="岗位意向"
      >
        <template #input>
          <van-radio-group v-model="form.jobIntention" @change="onJobIntentionChange">
            <van-radio name="TALENT">推广达人</van-radio>
            <van-radio name="COUNTY">区（县）服务商</van-radio>
            <van-radio name="CITY">市服务商</van-radio>
            <van-radio name="PROVINCE">省服务商(需预交9800元保证金)</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <template v-if="showIntentionAreaCon">
        <van-field
            v-model="form.intentionArea1"
            :rules="formRules.intentionArea1"
            name="intentionArea1"
            is-link
            readonly
            label="意向地区1"
            placeholder="请选择意向地区1"
            @click="showIntentionArea1 = true"
        />
        <van-popup v-model="showIntentionArea1" round position="bottom">
          <van-cascader
              v-model="cascaderIntentionArea1"
              title="请选择意向地区1"
              :options="intentionAreaOptions"
              :field-names="fieldNames"
              @close="showIntentionArea1 = false"
              @change="obj => onIntentionAreaChange(obj, '1')"
              @finish="obj => onIntentionAreaFinish(obj, '1')"
          />
        </van-popup>
        <van-field
            v-model="form.intentionArea2"
            :rules="formRules.intentionArea2"
            name="intentionArea2"
            is-link
            readonly
            label="意向地区2"
            placeholder="请选择意向地区2"
            @click="showIntentionArea2 = true"
        />
        <van-popup v-model="showIntentionArea2" round position="bottom">
          <van-cascader
              v-model="cascaderIntentionArea2"
              title="请选择意向地区2"
              :options="intentionAreaOptions"
              :field-names="fieldNames"
              @close="showIntentionArea2 = false"
              @change="obj => onIntentionAreaChange(obj, '2')"
              @finish="obj => onIntentionAreaFinish(obj, '2')"
          />
        </van-popup>
        <van-field
            v-model="form.intentionArea3"
            :rules="formRules.intentionArea3"
            name="intentionArea3"
            is-link
            readonly
            label="意向地区3"
            placeholder="请选择意向地区3"
            @click="showIntentionArea3 = true"
        />
        <van-popup v-model="showIntentionArea3" round position="bottom">
          <van-cascader
              v-model="cascaderIntentionArea3"
              title="请选择意向地区3"
              :options="intentionAreaOptions"
              :field-names="fieldNames"
              @close="showIntentionArea3 = false"
              @change="obj => onIntentionAreaChange(obj, '3')"
              @finish="obj => onIntentionAreaFinish(obj, '3')"
          />
        </van-popup>
      </template>

      <van-field
          v-model="form.promotion"
          :rules="formRules.promotion"
          name="promotion"
          rows="3"
          autosize
          label="人才晋升通道"
          type="textarea"
          maxlength="500"
          placeholder="(选填) 特殊人才请填个人简介"
          show-word-limit
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="button" @click="handleSubmit">提交</van-button>
      </div>
      <div class="tip-text">如有疑问，请联系客服电话：400-883-5650</div>
    </van-form>
  </div>
</div>
</template>

<script>
import { debounce } from '@/utils/common'
import { areaList } from '@/api/mall/mallLogistics'
import { addEnroll } from '@/api/mall/mallContent'
// import { getIndustries } from '@/api/mall/mallSystem'
export default {
  data(){
    return {
      form: {
        age: '',
        areaId: '',
        gender: '',
        industryId: '',
        industryName: '',
        inviterName: '',
        inviterPhone: '',
        jobIntention: '',
        jobWay: '',
        name: '',
        nativePlace: '',
        permanent: '',
        phone: '',
        intentionArea1: '',
        intentionArea2: '',
        intentionArea3: '',
        promotion: '',
      },
      formRules: {
        name: [
          { required: true, message: '请填写姓名' },
          { pattern: /.{2,12}/, message: '请输入2~12字' }
        ],
        gender: [{ required: true, message: '请选择性别' }],
        age: [
          { required: true, message: '请填写年龄'},
          { pattern: /^((1[0-5])|[1-9])?\d$/, message: '请输入正确的年龄范围' }
        ],
        phone: [
          { required: true, message: '请填写手机号码' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码' }
        ],
        nativePlace: [{ required: true, message: '请填写籍贯' }],
        permanent: [{ required: true, message: '请选择常住地' }],
        inviterName: [
          { validator: this.validatorInviterName, message: '请输入2~12字' }
        ],
        inviterPhone: [
          { validator: this.validatorInviterPhone, message: '请输入正确的手机号码' }
        ],
        industryName: [
          { required: true, message: '请填写所属行业' },
          { pattern: /.{2,20}/, message: '请输入2~20字' }
        ],
        jobWay: [{ required: true, message: '请选择工作方式' }],
        jobIntention: [{ required: true, message: '请选择岗位意向' }],
        intentionArea1: [{ required: true, message: '请选择意向地区1' }],
        intentionArea2: [{ required: false, message: '请选择意向地区2' }],
        intentionArea3: [{ required: false, message: '请选择意向地区3' }],
        promotion: [{ required: false, message: '请填写特殊人才请填个人简介' }],
      },
      // 籍贯
      nativePlaceOptions: [],
      showNativePlace: false,
      cascaderNativePlace: '', // 级联的最后一级所选id
      // 常住地区
      permanentOptions: [],
      showPermanent: false,
      cascaderPermanent: '', // 级联的最后一级所选id

      // 意向地区
      showIntentionAreaCon: false,
      intentionAreaOptions: [],
      // 意向地区1
      cascaderIntentionArea1: '',
      showIntentionArea1: false,
      // 意向地区2
      cascaderIntentionArea2: '',
      showIntentionArea2: false,
      // 意向地区3
      cascaderIntentionArea3: '',
      showIntentionArea3: false,

      // 行业
      industries: [],
      showIndustryNamePicker: false,

      // 级联选择器的字段名
      fieldNames: {
        text: 'areaName',
        value: 'areaId',
      },
    }
  },
  created(){
    this.getAreaList({areaId: 0, mapType: 'JD'}, {areaLevel:1})
  },
  methods: {
    handleSubmit: debounce(function() {
      this.onSubmit()
    }, 500),
    onSubmit() {
      this.$refs['form'].validate().then(()=>{
        let req = {
          name: this.form.name,
          gender: this.form.gender,
          age: this.form.age,
          phone: this.form.phone,
          nativePlace: this.form.nativePlace,
          permanent: this.form.permanent,
          industryName: this.form.industryName,
          jobWay: this.form.jobWay,
          jobIntention: this.form.jobIntention,
          promotion: this.form.promotion,
          areaId: this.form.areaId,
        }
        if(this.form.inviterName){
          req.inviterName = this.form.inviterName
        }
        if(this.form.inviterPhone){
          req.inviterPhone = this.form.inviterPhone
        }
        if(this.form.intentionArea1){
          req.intentionArea1 = this.form.intentionArea1
        }
        if(this.form.intentionArea2){
          req.intentionArea2 = this.form.intentionArea2
        }
        if(this.form.intentionArea3){
          req.intentionArea3 = this.form.intentionArea3
        }
        // console.log(req)
        let lastAddTime = this.local('addEnrollTime202311') || ''
        if(lastAddTime) {
          let now = Date.now()
          let minute = 5  // 间隔时长
          if(now-lastAddTime > minute * 60 * 1000) {
            this.addEnroll(req)
          }else {
            this.$toast.fail(`${minute}分钟内只能提交一次哦！`)
          }
        }else {
          this.addEnroll(req)
        }
      })
    },
    addEnroll(req){
      addEnroll(req).then(res => {
        if(res.code===200){
          this.$toast.success('提交成功！')
          this.local('addEnrollTime202311', Date.now())
          setTimeout(()=>{
            this.resetForm()
          }, 200)
        } else {
          this.$toast.fail(res.message);
        }
      })
    },

    resetForm(){
      this.form.age = ''
      this.form.areaId = ''
      this.form.gender = ''
      // this.form.industryId = ''
      this.form.industryName = ''
      this.form.inviterName = ''
      this.form.inviterPhone = ''
      this.form.jobIntention = ''
      this.form.jobWay = ''
      this.form.name = ''
      this.form.nativePlace = ''
      this.form.permanent = ''
      this.form.phone = ''
      this.form.intentionArea1 = ''
      this.form.intentionArea2 = ''
      this.form.intentionArea3 = ''
      this.form.promotion = ''
      this.$refs['form'].resetValidation()
      this.cascaderNativePlace = ''
      this.cascaderPermanent = ''
      this.showIntentionAreaCon = false
    },
    validatorInviterName(value, rule){
      // if(!value){
      //   return true
      // }else {
      //   let reg = /.{2,12}/
      //   if(reg.test(value)){
      //     return true
      //   }else {
      //     return false
      //   }
      // }

      let reg = /.{2,12}/
      if(reg.test(value)) {
        return true
      }else {
        return false
      }
    },
    validatorInviterPhone(value, rule){
      // if(!value){
      //   return true
      // }else {
      //   let reg = /^1[3456789]\d{9}$/
      //   if(reg.test(value)) {
      //     return true
      //   }else {
      //     return false
      //   }
      // }

      let reg = /^1[3456789]\d{9}$/
      if(reg.test(value)) {
        return true
      }else {
        return false
      }
    },

    // 岗位意向change
    onJobIntentionChange(val) {
      this.form.intentionArea1 = ''
      this.form.intentionArea2 = ''
      this.form.intentionArea3 = ''
      this.cascaderIntentionArea1 = ''
      this.cascaderIntentionArea2 = ''
      this.cascaderIntentionArea3 = ''
      this.intentionAreaOptions = []
      if (val==='TALENT') {
        this.showIntentionAreaCon = false
      }else {
        let opt = {}
        if(val==='PROVINCE') {
          opt = {areaLevel: 1, type: 'intentionArea', intentionArea: 'PROVINCE'}
        }else if(val==='CITY') {
          opt = {areaLevel: 1, type: 'intentionArea', intentionArea: 'CITY'}
        }else if(val==='COUNTY') {
          opt = {areaLevel: 1, type: 'intentionArea', intentionArea: 'COUNTY'}
        }
        this.getAreaList({areaId: 0, mapType: 'JD'}, opt)
        this.showIntentionAreaCon = true
      }
    },

    // 选择籍贯
    onNativePlaceChange( obj ) {
      // obj.selectedOptions.slice(-1)[0] -----   级联中最后一级的option
      if(obj.selectedOptions.slice(-1)[0].areaLevel===1){
        this.getAreaList({areaId: obj.value, mapType: 'JD'}, {areaLevel: 2, type: 'nativePlace'}, obj.selectedOptions)
      }
    },
    onNativePlaceFinish({ selectedOptions }) {
      this.showNativePlace = false;
      this.form.nativePlace = selectedOptions.map((option) => option.areaName).join('-');
    },

    // 选择常住地区
    onPermanentChange( obj ) {
      // obj.selectedOptions.slice(-1)[0] -----   级联中最后一级的option
      let opt = {}
      if(obj.selectedOptions.slice(-1)[0].areaLevel===1){
        opt = {areaLevel: 2, type: 'permanent'}

      }else if(obj.selectedOptions.slice(-1)[0].areaLevel===2){
        opt = {areaLevel: 3, type: 'permanent'}
      }
      this.getAreaList({areaId: obj.value, mapType: 'JD'}, opt, obj.selectedOptions)
    },
    onPermanentFinish({ selectedOptions }) {
      this.showPermanent = false;
      this.form.permanent = selectedOptions.map((option) => option.areaName).join('-');
      this.form.areaId = selectedOptions.slice(-1)[0].areaId
    },

    // 选择意向地区
    onIntentionAreaChange(obj, areaNo) { // value, selectedOptions, tabIndex
      let opt = {}
      if(obj.selectedOptions.slice(-1)[0].areaLevel===1){
        opt = {areaLevel: 2, type: 'intentionArea'}
      }else if(obj.selectedOptions.slice(-1)[0].areaLevel===2){
        opt = {areaLevel: 3, type: 'intentionArea'}
      }
      this.getAreaList({areaId: obj.value, mapType: 'JD'}, opt, obj.selectedOptions)
    },
    onIntentionAreaFinish(obj, areaNo) { // value, selectedOptions, tabIndex
      if(areaNo==='1'){
        this.showIntentionArea1 = false;
        this.form.intentionArea1 = obj.selectedOptions.map((option) => option.areaName).join('-');
      }else if(areaNo==='2'){
        this.showIntentionArea2 = false;
        this.form.intentionArea2 = obj.selectedOptions.map((option) => option.areaName).join('-');
      }else if(areaNo==='3'){
        this.showIntentionArea3 = false;
        this.form.intentionArea3 = obj.selectedOptions.map((option) => option.areaName).join('-');
      }
    },

    // 选择行业
    // onIndustriesConfirm(value){
    //   this.form.industryName = value.industryName;
    //   this.showIndustryNamePicker = false;
    // },

    // 获取地区
    getAreaList(req, opt, selectedOptions){
      // console.log(selectedOptions)
      areaList(req).then(res=>{
        if (opt.areaLevel ===1) {
          if(opt.type==='intentionArea') {
            this.intentionAreaOptions = res.data.map(item => {
              let obj = {...item}
              if(opt.intentionArea==='CITY' || opt.intentionArea==='COUNTY'){
                obj.children = []
              }
              return obj
            })
          } else {
            this.nativePlaceOptions = res.data.map(item => {
              return {
                ...item,
                children: []
              }
            })
            this.permanentOptions = res.data.map(item => {
              return {
                ...item,
                children: []
              }
            })
          }
        }else if(opt.areaLevel ===2) {
          let items = []
          if(opt.type==='nativePlace'){
            items = res.data.map(item => {
              return {
                ...item
              }
            })
          }else if(opt.type==='permanent'){
            items = res.data.map(item => {
              return {
                ...item,
                children: []
              }
            })
          }else if(opt.type==='intentionArea'){
            items = res.data.map(item => {
              let obj = {...item}
              if(this.form.jobIntention==='COUNTY'){
                obj.children = []
              }
              return obj
            })
          }
          selectedOptions[selectedOptions.length-1].children = items
        }else if(opt.areaLevel ===3){
          selectedOptions[selectedOptions.length-1].children = res.data.map(item => {
            return {
              ...item
            }
          })
        }
      })
    },

  }
}
</script>

<style lang="less" scoped>
.info-page{
  width: 375px;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fdfdfd;
  .logo-con{
    background-color: #fff;
    padding: 14px 14px 10px;
    .logo{
      width: 140px;
    }
  }
  .title-con{
    background-color: #fff;
    text-align: center;
    padding-bottom: 10px;
    .title{
      font-size: 20px;
    }
    .title-sub{
      font-size: 14px;
    }
  }
  .form-con{
    .jobIntention{
      .van-radio{
        margin-bottom: 6px;
      }
    }

    .tip-text{
      margin: 20px;
      text-align: center;
      font-size: 14px;
      color: #888;
    }
  }
}
</style>
